import { useTranslation } from "react-i18next";
import { MailPlus } from "lucide-react";
import { InvitePanel } from "./InvitePanel";

// تبويب الدعوات: مقدمة توضيحية + نموذج InvitePanel الحالي (لا نغيّر منطقه).
export const EmployeesInvitesTab = ({ invites, branches, reload }) => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-5" data-testid="employees-invites-tab">
      <div className="neu flex items-start gap-4 p-5">
        <div className="grid h-11 w-11 place-items-center rounded-2xl bg-primary/10 text-primary shadow-neu-in">
          <MailPlus className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold text-foreground">{t("invites.title")}</p>
          <p className="mt-1 text-xs text-muted-foreground">{t("join.noSelfSignup")}</p>
        </div>
      </div>
      <InvitePanel invites={invites} branches={branches} reload={reload} />
    </div>
  );
};
